<template>
  <v-menu :close-on-content-click="false" offset-y>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        class="py-1 d-print-none font-weight-bold overflow-hidden"
        outlined
        color="primary"
        dark
        small
        v-bind="attrs"
        v-on="on"
        style="text-overflow: ellipsis; width: 150px !important"
      >
        Status Filter
        <v-icon v-if="selectedStates.length > 0" right>mdi-filter-variant-plus</v-icon>
        <v-icon v-else right>mdi-filter-variant</v-icon>
      </v-btn>
    </template>
    <v-list>
      <v-list-item-group v-model="selectedStates" multiple>
        <v-list-item v-for="(state, index) in states" :key="index" :value="state">
          <v-chip width="100%" :style="`background:${state.bgColor};color:white`">
            <v-avatar v-if="selectedStates.find((s) => s.id === state.id)" left>
              <v-icon>mdi-checkbox-marked-circle</v-icon>
            </v-avatar>
            {{ state.text }}
          </v-chip>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </v-menu>
</template>
<script>
export default {
  name: 'StateFilter',
  props: {
    states: Array,
    values: Array, // the selected states
  },
  data() {
    return {
      selectedStates: this.values ? this.values : [],
    };
  },
  watch: {
    selectedStates(newValue, oldValue) {
      this.$emit('input', newValue);
    },
    values(newValue, oldValue) {
      this.selectedStates = newValue;
    },
  },
};
</script>
